import { useState } from "react";
import {
  UpdateCommitmentActualHoursRequest,
  useRelationshipsRelationshipUpdateCommitmentActualHoursMutation,
} from "@/services/backend/relationships/api/service";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { Commitment } from "@/services/backend/relationships/types/relationship";
import { Input } from "@/shared/components/ui/input";
import { tableInputClass } from "@/shared/components/tables/table-input-class";
import { cn } from "@/shared/lib/utils";

export function ActualHoursCell({ commitment }: { commitment: Commitment }) {
  const [request, setRequest] = useState<UpdateCommitmentActualHoursRequest>({
    id: commitment.relationshipId,
    commitmentId: commitment.id,
    actualHours: commitment.actualHours,
  });
  const mutation =
    useRelationshipsRelationshipUpdateCommitmentActualHoursMutation();
  useDebouncedMutation(request, setRequest, mutation, {
    id: commitment.relationshipId,
    commitmentId: commitment.id,
    actualHours: commitment.actualHours,
  });

  return (
    <Input
      type="number"
      className={cn(tableInputClass, "ml-0 w-16")}
      value={request.actualHours / 8}
      onChange={(e) =>
        setRequest({ ...request, actualHours: Number(e.target.value) * 8 })
      }
    />
  );
}
